import React from 'react';
import ButtonPrimary from 'components/atoms/buttons/standard/Primary';
import styled from 'styled-components';
import DisableOverlay from 'components/atoms/DisableOverlay';

const AdBlockWarning = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 50%;
    background-color: #F6E6C4;
    color: #3D3D3D;
    padding: 25px;
    border-radius: 5px;
    font-size: 16px;
    cursor: not-allowed;
`;


const AdBlockModal = props => (
    <DisableOverlay className="disabledDiv">
        <AdBlockWarning>
            <h3><b>Help Us Help You!</b></h3>
            <p> We noticed that you are using an adblocker.
                By doing so, you block many tools that Goodway uses to support G90 applications.
                Please disable your adblocker or add 'portal.goodwaygroup.com' to your whitelist.</p>
            <p>This message will not appear once your adblocker is disabled.</p>
            <br />
            <ButtonPrimary onClick={() => props.handleClick()}>I UNDERSTAND</ButtonPrimary>

            <br />
        </AdBlockWarning>
    </DisableOverlay>
);

export default AdBlockModal;



// WEBPACK FOOTER //
// ./src/components/molecules/modal/AdBlockerModal.js